import { render, staticRenderFns } from "./AuthChange.vue?vue&type=template&id=7fdb4877"
import script from "./AuthChange.vue?vue&type=script&lang=js"
export * from "./AuthChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports